<div
  [ngClass]="{
    green: progress < 40,
    orange: progress >= 40 && progress < 70,
    red: progress >= 70,
    mini: mini,
  }"
  class="progress-container"
>
  @if (!mini) {
    <typography-v2 class="text">Lead reassigns in {{ duration - progress }} sec</typography-v2>
  }

  <div
    [ngClass]="{
      green: progress < 40,
      orange: progress >= 40 && progress < 70,
      red: progress >= 70,
    }"
    class="progress-bar"
    [style.width.%]="progress"
  ></div>
</div>
